import { useEffect, useRef, useState } from 'react'
import { Download, RotateCcw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useWorkspace } from '@/domain/context'
import { tx } from '@/lib/i18n'
import { safePageReload } from '@/lib/safe-page-reload'
import { ErrorMessage } from './shared'

export function RouteLoadRecovery({ onExport }: { onExport: () => void }) {
  const { drainPending } = useWorkspace()
  const [busy, setBusy] = useState(false), [error, setError] = useState('')
  const heading = useRef<HTMLHeadingElement>(null)
  useEffect(() => { heading.current?.focus({ preventScroll: true }) }, [])
  const reload = async () => {
    setBusy(true); setError('')
    try { await safePageReload(drainPending) }
    catch (issue) { setError(issue instanceof Error ? issue.message : String(issue)); setBusy(false) }
  }
  return <section data-testid="route-load-recovery" className="mx-auto w-full max-w-xl space-y-5 px-4 py-8 sm:px-6" aria-labelledby="route-recovery-title">
    <h1 ref={heading} id="route-recovery-title" tabIndex={-1} className="text-2xl font-semibold tracking-tight outline-none">{tx('This view could not be loaded.')}</h1>
    <p role="alert" className="text-base leading-6 text-muted-foreground">{tx('Your saved workspace and practice progress are unchanged. Reload this page to open the current version.')}</p>
    <ErrorMessage error={error}/>
    <div className="flex flex-wrap gap-3">
      <Button data-testid="route-reload" disabled={busy} onClick={() => void reload()}><RotateCcw/>{tx('Reload current page')}</Button>
      <Button data-testid="route-export" variant="outline" disabled={busy} onClick={onExport}><Download/>{tx('Export saved workspace')}</Button>
    </div>
  </section>
}
